import { render, staticRenderFns } from "./ItemStatsDisplay.vue?vue&type=template&id=298dc332"
import script from "./ItemStatsDisplay.vue?vue&type=script&lang=js"
export * from "./ItemStatsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports